import React from 'react'

import { Breadcrumbs } from "/react4xp/shared/breadcrumbs/breadcrumbs";

export default (props) => <Breadcrumbs {...props} />
